export default __webpack_public_path__ + "static/media/flutterwaveLogo.b32d7ad5.webp";